import React, { createContext, useContext } from 'react';
export type Lang = 'en' | 'no' | 'sv' | 'da';
const translations: Record<Lang, Record<string, string>> = {
  en: {
    // Language selector
    'lang.headline': 'Invest the next 18 seconds to see how you can save 18 minutes on all future bonding appointments!',
    'lang.subtitle': 'Select your language to start',
    'hook.subtitle': "Tap start when you're ready — the clock begins now.",
    'hook.start': 'Start the 18 seconds →',
    // SlideOne
    'poll.headline': 'How would you use 18 minutes saved at every bonding?',
    'poll.subtitle': 'See what your peers choose',
    'poll.option0': 'Spend more time in the mountains 🏔️',
    'poll.option1': 'Add one more patient',
    'poll.option2': 'Stay on schedule',
    'poll.cta': '👉 See how this could be you →',
    // SlideTwo
    back: 'Back',
    'results.pollLabel': 'Poll results',
    'results.you': '← you',
    'results.agree': '{pct}% of your peers agree with you',
    'results.headline0': 'Your peers agree — more time for the moments that matter',
    'results.headline1': 'Your peers agree — more capacity without more stress',
    'results.headline2': 'Your peers agree — staying on time matters most',
    'results.body0': "What if bonding took 2 minutes instead of 20? That's 18 minutes back — enough to leave on time and hit the trails.",
    'results.body1': 'With 18 minutes saved per bonding appointment, you could see one additional patient daily — without rushing anyone.',
    'results.body2': 'When bonding takes 2 minutes instead of 20, staying on schedule stops being a goal — it becomes the default.',
    'results.cta': '👉 See how this could be you →',
    'results.next': 'Next →',
    // SlideThree
    'proof.from': 'From',
    'proof.headline': 'From 20 minutes to 2',
    'proof.quote': '"Previously, bonding could take around 20 minutes… now it only takes a couple of minutes."',
    'proof.reality': 'With digital bonding, this is not a fantasy — but a reality',
    'proof.substep': 'Digital planning + full-arch bonding in one step',
    'proof.cta': '👉 See how this could be you →',
    // SlideFour
    'cta.headline0': 'How to get more time in the mountains',
    'cta.headline1': 'How to see more patients',
    'cta.headline2': 'How to stay on schedule',
    'cta.headlineDefault': 'How to get started',
    'cta.subtitle': 'Choose the option that works best for you',
    'cta.promiseKept': '✓ Promise kept! That took just {seconds} seconds.',
    'cta.promiseBroken': "Sorry, that took a few more seconds — but the 18 minutes you'll save are worth it!",
    'cta.webMeetingTitle': 'Contact me for a short web meeting',
    'cta.webMeetingDesc': 'A quick 15-minute call to see how digital bonding fits your clinic',
    'cta.materialTitle': 'Send me material on getting started',
    'cta.materialDesc': 'Receive info on how to get started with digital bonding at your clinic',
    // SlideFive
    'form.headingMeeting': 'Book your web meeting',
    'form.headingMaterial': 'Get your starter material',
    'form.subMeeting': "We'll reach out to schedule a short 15-minute call.",
    'form.subMaterial': "We'll send everything you need to get started.",
    'form.name': 'Name',
    'form.role': 'Role',
    'form.clinic': 'Clinic',
    'form.address': 'Address',
    'form.email': 'Email',
    'form.phone': 'Phone',
    'form.namePlaceholder': 'Full name',
    'form.rolePlaceholder': 'e.g. Orthodontist',
    'form.clinicPlaceholder': 'Clinic name',
    'form.addressPlaceholder': 'Clinic address',
    'form.phonePlaceholder': '+47 000 00 000',
    'form.consent': 'I consent to Solventum processing my personal data to respond to my request. I understand I can withdraw my consent at any time.',
    'form.privacy': 'Privacy Policy',
    'form.submitMeeting': 'Request my meeting',
    'form.submitMaterial': 'Send me the material',
    'form.thankYou': 'Thank you!',
    'form.thankMeeting': "We'll be in touch shortly to schedule your meeting.",
    'form.thankMaterial': 'Your material is on its way to your inbox.',
    'form.thankFooter': 'We look forward to helping you save time with digital bonding.',
    // CountdownTimer
    'timer.discover': 'seconds to discover',
    'timer.saved': '18 min saved!',
    'timer.spent': '{seconds}s spent',
    // Footer
    footer: '© Solventum 2026'
  },
  no: {
    'lang.headline': 'Invester de neste 18 sekundene for å se hvordan du kan spare 18 minutter på alle fremtidige bonding-avtaler!',
    'lang.subtitle': 'Velg språk for å starte',
    'hook.subtitle': 'Trykk start når du er klar — klokken starter nå.',
    'hook.start': 'Start de 18 sekundene →',
    'poll.headline': 'Hva ville du brukt 18 sparte minutter på ved hver bonding?',
    'poll.subtitle': 'Se hva kollegene dine velger',
    'poll.option0': 'Mer tid på fjellet 🏔️',
    'poll.option1': 'Ta imot én pasient til',
    'poll.option2': 'Holde tidsskjemaet',
    'poll.cta': '👉 Se hvordan dette kan bli deg →',
    back: 'Tilbake',
    'results.pollLabel': 'Resultater',
    'results.you': '← deg',
    'results.agree': '{pct}% av kollegene dine er enige med deg',
    'results.headline0': 'Kollegene dine er enige — mer tid til det som betyr noe',
    'results.headline1': 'Kollegene dine er enige — flere pasienter uten mer stress',
    'results.headline2': 'Kollegene dine er enige — å holde tiden er viktigst',
    'results.body0': 'Hva om bonding tok 2 minutter i stedet for 20? Det er 18 minutter tilbake — nok til å dra hjem i tide og komme seg på fjellet.',
    'results.body1': 'Med 18 minutter spart per bonding-avtale kan du ta imot én ekstra pasient daglig — uten å stresse.',
    'results.body2': 'Når bonding tar 2 minutter i stedet for 20, slutter det å holde tidsskjemaet å være et mål — det blir standarden.',
    'results.cta': '👉 Se hvordan dette kan bli deg →',
    'results.next': 'Neste →',
    'proof.from': 'Fra',
    'proof.headline': 'Fra 20 minutter til 2',
    'proof.quote': '"Tidligere kunne bonding ta rundt 20 minutter… nå tar det bare et par minutter."',
    'proof.reality': 'Med digital bonding er dette ikke en fantasi — men en realitet',
    'proof.substep': 'Digital planlegging + full-arch bonding i ett steg',
    'proof.cta': '👉 Se hvordan dette kan bli deg →',
    'cta.headline0': 'Slik får du mer tid på fjellet',
    'cta.headline1': 'Slik kan du ta imot flere pasienter',
    'cta.headline2': 'Slik holder du tidsskjemaet',
    'cta.headlineDefault': 'Slik kommer du i gang',
    'cta.subtitle': 'Velg det alternativet som passer best for deg',
    'cta.promiseKept': '✓ Løfte holdt! Det tok bare {seconds} sekunder.',
    'cta.promiseBroken': 'Beklager, det tok noen sekunder ekstra — men de 18 minuttene du sparer er verdt det!',
    'cta.webMeetingTitle': 'Kontakt meg for et kort webmøte',
    'cta.webMeetingDesc': 'En rask 15-minutters samtale for å se hvordan digital bonding passer din klinikk',
    'cta.materialTitle': 'Send meg materiell om å komme i gang',
    'cta.materialDesc': 'Motta informasjon om hvordan du starter med digital bonding på din klinikk',
    'form.headingMeeting': 'Bestill ditt webmøte',
    'form.headingMaterial': 'Få startmateriellet ditt',
    'form.subMeeting': 'Vi tar kontakt for å avtale en kort 15-minutters samtale.',
    'form.subMaterial': 'Vi sender alt du trenger for å komme i gang.',
    'form.name': 'Navn',
    'form.role': 'Rolle',
    'form.clinic': 'Klinikk',
    'form.address': 'Adresse',
    'form.email': 'E-post',
    'form.phone': 'Telefon',
    'form.namePlaceholder': 'Fullt navn',
    'form.rolePlaceholder': 'f.eks. Kjeveortoped',
    'form.clinicPlaceholder': 'Klinikknavn',
    'form.addressPlaceholder': 'Klinikkadresse',
    'form.phonePlaceholder': '+47 000 00 000',
    'form.consent': 'Jeg samtykker til at Solventum behandler mine personopplysninger for å svare på min forespørsel. Jeg forstår at jeg kan trekke tilbake mitt samtykke når som helst.',
    'form.privacy': 'Personvernerklæring',
    'form.submitMeeting': 'Be om mitt møte',
    'form.submitMaterial': 'Send meg materiellet',
    'form.thankYou': 'Takk!',
    'form.thankMeeting': 'Vi tar kontakt snart for å avtale møtet ditt.',
    'form.thankMaterial': 'Materiellet er på vei til innboksen din.',
    'form.thankFooter': 'Vi ser frem til å hjelpe deg spare tid med digital bonding.',
    'timer.discover': 'sekunder igjen',
    'timer.saved': '18 min spart!',
    'timer.spent': '{seconds}s brukt',
    footer: '© Solventum 2026'
  },
  sv: {
    'lang.headline': 'Investera de nästa 18 sekunderna för att se hur du kan spara 18 minuter på alla framtida bonding-besök!',
    'lang.subtitle': 'Välj ditt språk för att börja',
    'hook.subtitle': 'Tryck på start när du är redo — klockan börjar nu.',
    'hook.start': 'Starta de 18 sekunderna →',
    'poll.headline': 'Vad skulle du göra med 18 sparade minuter vid varje bonding?',
    'poll.subtitle': 'Se vad dina kollegor väljer',
    'poll.option0': 'Mer tid i fjällen 🏔️',
    'poll.option1': 'Ta emot en patient till',
    'poll.option2': 'Hålla tidsschemat',
    'poll.cta': '👉 Se hur detta kan bli du →',
    back: 'Tillbaka',
    'results.pollLabel': 'Resultat',
    'results.you': '← du',
    'results.agree': '{pct}% av dina kollegor håller med dig',
    'results.headline0': 'Dina kollegor håller med — mer tid för det som betyder något',
    'results.headline1': 'Dina kollegor håller med — fler patienter utan mer stress',
    'results.headline2': 'Dina kollegor håller med — att hålla tiden är viktigast',
    'results.body0': 'Tänk om bonding tog 2 minuter istället för 20? Det är 18 minuter tillbaka — tillräckligt för att åka hem i tid och ta sig ut i fjällen.',
    'results.body1': 'Med 18 minuter sparade per bonding-besök kan du ta emot en extra patient dagligen — utan att stressa.',
    'results.body2': 'När bonding tar 2 minuter istället för 20 slutar det att hålla schemat vara ett mål — det blir standard.',
    'results.cta': '👉 Se hur detta kan bli du →',
    'results.next': 'Nästa →',
    'proof.from': 'Från',
    'proof.headline': 'Från 20 minuter till 2',
    'proof.quote': '"Tidigare kunde bonding ta runt 20 minuter… nu tar det bara ett par minuter."',
    'proof.reality': 'Med digital bonding är detta inte en fantasi — utan verklighet',
    'proof.substep': 'Digital planering + full-arch bonding i ett steg',
    'proof.cta': '👉 Se hur detta kan bli du →',
    'cta.headline0': 'Så får du mer tid i fjällen',
    'cta.headline1': 'Så kan du ta emot fler patienter',
    'cta.headline2': 'Så håller du tidsschemat',
    'cta.headlineDefault': 'Så kommer du igång',
    'cta.subtitle': 'Välj det alternativ som passar dig bäst',
    'cta.promiseKept': '✓ Löfte hållet! Det tog bara {seconds} sekunder.',
    'cta.promiseBroken': 'Förlåt, det tog några sekunder extra — men de 18 minuterna du sparar är värda det!',
    'cta.webMeetingTitle': 'Kontakta mig för ett kort webbmöte',
    'cta.webMeetingDesc': 'Ett snabbt 15-minuterssamtal för att se hur digital bonding passar din klinik',
    'cta.materialTitle': 'Skicka mig material om att komma igång',
    'cta.materialDesc': 'Få information om hur du startar med digital bonding på din klinik',
    'form.headingMeeting': 'Boka ditt webbmöte',
    'form.headingMaterial': 'Få ditt startmaterial',
    'form.subMeeting': 'Vi hör av oss för att boka ett kort 15-minuterssamtal.',
    'form.subMaterial': 'Vi skickar allt du behöver för att komma igång.',
    'form.name': 'Namn',
    'form.role': 'Roll',
    'form.clinic': 'Klinik',
    'form.address': 'Adress',
    'form.email': 'E-post',
    'form.phone': 'Telefon',
    'form.namePlaceholder': 'Fullständigt namn',
    'form.rolePlaceholder': 't.ex. Ortodontist',
    'form.clinicPlaceholder': 'Kliniknamn',
    'form.addressPlaceholder': 'Klinikadress',
    'form.phonePlaceholder': '+46 000 00 000',
    'form.consent': 'Jag samtycker till att Solventum behandlar mina personuppgifter för att svara på min förfrågan. Jag förstår att jag kan återkalla mitt samtycke när som helst.',
    'form.privacy': 'Integritetspolicy',
    'form.submitMeeting': 'Begär mitt möte',
    'form.submitMaterial': 'Skicka mig materialet',
    'form.thankYou': 'Tack!',
    'form.thankMeeting': 'Vi hör av oss snart för att boka ditt möte.',
    'form.thankMaterial': 'Materialet är på väg till din inkorg.',
    'form.thankFooter': 'Vi ser fram emot att hjälpa dig spara tid med digital bonding.',
    'timer.discover': 'sekunder kvar',
    'timer.saved': '18 min sparade!',
    'timer.spent': '{seconds}s använt',
    footer: '© Solventum 2026'
  },
  da: {
    'lang.headline': 'Invester de næste 18 sekunder for at se, hvordan du kan spare 18 minutter på alle fremtidige bonding-aftaler!',
    'lang.subtitle': 'Vælg dit sprog for at starte',
    'hook.subtitle': 'Tryk start, når du er klar — uret starter nu.',
    'hook.start': 'Start de 18 sekunder →',
    'poll.headline': 'Hvad ville du bruge 18 sparede minutter på ved hver bonding?',
    'poll.subtitle': 'Se hvad dine kollegaer vælger',
    'poll.option0': 'Mere tid med familien 👨‍👩‍👧‍👦',
    'poll.option1': 'Tage imod én patient mere',
    'poll.option2': 'Holde tidsplanen',
    'poll.cta': '👉 Se hvordan dette kan blive dig →',
    back: 'Tilbage',
    'results.pollLabel': 'Resultater',
    'results.you': '← dig',
    'results.agree': '{pct}% af dine kollegaer er enige med dig',
    'results.headline0': 'Dine kollegaer er enige — mere tid med dem der betyder mest',
    'results.headline1': 'Dine kollegaer er enige — flere patienter uden mere stress',
    'results.headline2': 'Dine kollegaer er enige — at holde tiden er vigtigst',
    'results.body0': 'Hvad hvis bonding tog 2 minutter i stedet for 20? Det er 18 minutter tilbage — nok til at tage hjem til tiden og være sammen med familien.',
    'results.body1': 'Med 18 minutter sparet per bonding-aftale kan du tage imod én ekstra patient dagligt — uden at stresse.',
    'results.body2': 'Når bonding tager 2 minutter i stedet for 20, holder du ikke bare tidsplanen — det bliver standarden.',
    'results.cta': '👉 Se hvordan dette kan blive dig →',
    'results.next': 'Næste →',
    'proof.from': 'Fra',
    'proof.headline': 'Fra 20 minutter til 2',
    'proof.quote': '"Tidligere kunne bonding tage omkring 20 minutter… nu tager det kun et par minutter."',
    'proof.reality': 'Med digital bonding er dette ikke en fantasi — men virkelighed',
    'proof.substep': 'Digital planlægning + full-arch bonding i ét trin',
    'proof.cta': '👉 Se hvordan dette kan blive dig →',
    'cta.headline0': 'Sådan får du mere tid med familien',
    'cta.headline1': 'Sådan kan du tage imod flere patienter',
    'cta.headline2': 'Sådan holder du tidsplanen',
    'cta.headlineDefault': 'Sådan kommer du i gang',
    'cta.subtitle': 'Vælg den mulighed der passer dig bedst',
    'cta.promiseKept': '✓ Løfte holdt! Det tog kun {seconds} sekunder.',
    'cta.promiseBroken': 'Beklager, det tog et par sekunder ekstra — men de 18 minutter du sparer er det værd!',
    'cta.webMeetingTitle': 'Kontakt mig for et kort webmøde',
    'cta.webMeetingDesc': 'Et hurtigt 15-minutters opkald for at se hvordan digital bonding passer din klinik',
    'cta.materialTitle': 'Send mig materiale om at komme i gang',
    'cta.materialDesc': 'Modtag information om hvordan du starter med digital bonding på din klinik',
    'form.headingMeeting': 'Bestil dit webmøde',
    'form.headingMaterial': 'Få dit startmateriale',
    'form.subMeeting': 'Vi kontakter dig for at aftale et kort 15-minutters opkald.',
    'form.subMaterial': 'Vi sender alt hvad du behøver for at komme i gang.',
    'form.name': 'Navn',
    'form.role': 'Rolle',
    'form.clinic': 'Klinik',
    'form.address': 'Adresse',
    'form.email': 'E-mail',
    'form.phone': 'Telefon',
    'form.namePlaceholder': 'Fulde navn',
    'form.rolePlaceholder': 'f.eks. Ortodontist',
    'form.clinicPlaceholder': 'Kliniknavn',
    'form.addressPlaceholder': 'Klinikadresse',
    'form.phonePlaceholder': '+45 000 00 000',
    'form.consent': 'Jeg giver samtykke til, at Solventum behandler mine personoplysninger for at besvare min forespørgsel. Jeg forstår, at jeg til enhver tid kan trække mit samtykke tilbage.',
    'form.privacy': 'Privatlivspolitik',
    'form.submitMeeting': 'Anmod om mit møde',
    'form.submitMaterial': 'Send mig materialet',
    'form.thankYou': 'Tak!',
    'form.thankMeeting': 'Vi kontakter dig snart for at aftale dit møde.',
    'form.thankMaterial': 'Materialet er på vej til din indbakke.',
    'form.thankFooter': 'Vi glæder os til at hjælpe dig spare tid med digital bonding.',
    'timer.discover': 'sekunder tilbage',
    'timer.saved': '18 min sparet!',
    'timer.spent': '{seconds}s brugt',
    footer: '© Solventum 2026'
  }
};
interface I18nContextType {
  lang: Lang;
  t: (key: string, params?: Record<string, string | number>) => string;
}
const I18nContext = createContext<I18nContextType>({
  lang: 'en',
  t: key => key
});
export function I18nProvider({
  lang,
  children
}: {
  lang: Lang;
  children: React.ReactNode;
}) {
  const t = (key: string, params?: Record<string, string | number>): string => {
    let text = translations[lang]?.[key] || translations['en']?.[key] || key;
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        text = text.replace(`{${k}}`, String(v));
      });
    }
    return text;
  };
  return <I18nContext.Provider value={{
    lang,
    t
  }} data-id="element-485">
      {children}
    </I18nContext.Provider>;
}
export function useT() {
  return useContext(I18nContext);
}